export default function expandTaskMiniactivities(
  taskActivities,
  includePrevNext = true
) {
  const expandedtaskActivities = [];
  for (let i = 0; i < taskActivities.length; i++) {
    const taskActivity = taskActivities[i];
    const { activityConf, activityProgress } = taskActivity;

    if (Array.isArray(activityConf.miniactivities)) {
      for (const taskMiniActivityConf of activityConf.miniactivities) {
        expandedtaskActivities.push({
          ...taskActivity,
          activityConf: taskMiniActivityConf,
          activityProgress: activityProgress
            ? getMiniactivityProgress(activityProgress, taskMiniActivityConf)
            : null,
          progresses: getTriesProgresses(
            taskActivity.progresses,
            taskMiniActivityConf
          ),
        });
      }
    } else {
      expandedtaskActivities.push({
        ...taskActivity,
        activityProgress: taskActivity.activityProgress?.[0],
      });
    }
  }

  let taskActivitiesLinked = expandedtaskActivities;
  if (includePrevNext) {
    taskActivitiesLinked = expandedtaskActivities.map(
      (taskActivity, index, expandedActivities) => {
        return {
          index,
          ...taskActivity,
          next:
            index < expandedActivities.length
              ? expandedActivities[index + 1]
              : null,
          prev: index > 0 ? expandedActivities[index - 1] : null,
        };
      }
    );
  }
  return taskActivitiesLinked;
}

export function getMiniactivityProgress(
  activityProgress,
  taskMiniActivityConf
) {
  return activityProgress?.find(
    (miniactivityProgress) =>
      miniactivityProgress.miniactivityType ==
      taskMiniActivityConf.miniactivityType
  );
}

export function getTriesProgresses(progresses, taskMiniActivityConf) {
  return progresses?.filter(
    (progressDetailItem) =>
      progressDetailItem.data?.miniactivityType ==
      taskMiniActivityConf.miniactivityType
  );
}
